import axios from 'axios';

export type SubscriptionFeature =
  | 'messages'
  | 'comments'
  | 'downloads'
  | 'materials_download'
  | 'calendar'
  | 'posts'
  | 'notifications'
  | 'homework_submit'
  | 'child_activation'
  | 'generic';

export const isSubscriptionError = (error: unknown) => {
  if (!axios.isAxiosError(error)) return false;
  if (Number(error.response?.status) !== 403) return false;
  const detail = String((error.response?.data as any)?.detail || '').toLowerCase();
  return (
    detail.includes('abonament') ||
    detail.includes('subscription') ||
    detail.includes('premium')
  );
};

export const getUpgradeCopy = (feature: SubscriptionFeature) => {
  if (feature === 'messages') {
    return {
      title: 'Trimite mesaje',
      body: 'Pentru a trimite mesaje ai nevoie de abonamentul Basic (3€) sau Full (5€).',
    };
  }
  if (feature === 'comments') {
    return {
      title: 'Comentarii',
      body: 'Pentru a comenta ai nevoie de abonamentul Basic (3€) sau Full (5€).',
    };
  }
  if (feature === 'downloads') {
    return {
      title: 'Descărcare resurse',
      body: 'Pentru a descărca resurse ai nevoie de abonamentul Full (5€).',
    };
  }
  if (feature === 'materials_download') {
    return {
      title: 'Descărcare cursuri/teme',
      body: 'Pentru a descărca cursuri și teme ai nevoie de abonamentul Basic (3€) sau Full (5€).',
    };
  }
  if (feature === 'calendar') {
    return {
      title: 'Calendar',
      body: 'Pentru a crea programări în calendar ai nevoie de abonamentul Basic (3€) sau Full (5€).',
    };
  }
  if (feature === 'posts') {
    return {
      title: 'Publicare postări',
      body: 'Pentru a publica postări ai nevoie de abonamentul Full (5€).',
    };
  }
  if (feature === 'notifications') {
    return {
      title: 'Notificări',
      body: 'Pentru a vedea notificările ai nevoie de un abonament activ.',
    };
  }
  if (feature === 'homework_submit') {
    return {
      title: 'Încărcare teme rezolvate',
      body: 'Pentru a încărca teme rezolvate ai nevoie de abonamentul Basic (3€) sau Full (5€).',
    };
  }
  if (feature === 'child_activation') {
    return {
      title: 'Activare cont copil',
      body: 'Pe abonamentul Free poți activa 1 cont copil. Pentru a activa mai mulți copii ai nevoie de abonamentul Basic (3€) sau Full (5€).',
    };
  }
  return {
    title: 'Funcționalitate premium',
    body: 'Această funcționalitate necesită un abonament.',
  };
};
